import "../../styles/ui/native-animations.scss";

import React, {useEffect, useRef, useState} from "react";
import cn from "classnames";

const Fade = ({visible, animate = true, children, className, ...props}) => {
    const [present, setPresent] = useState(visible);
    const elementRef = useRef(null);

    useEffect(() => {
        if (elementRef.current) elementRef.current.inert = !visible;

        if (visible) {
            setPresent(true);
            return;
        }

        if (!present) return;
        const reducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
        const timer = window.setTimeout(() => setPresent(false), reducedMotion ? 0 : 300);
        return () => window.clearTimeout(timer);
    }, [visible, present]);

    if (!visible && !present) return null;

    return (
        <div
            {...props}
            ref={elementRef}
            aria-hidden={!visible}
            className={cn(className, animate && (visible ? "ui-fade-in" : "ui-fade-out"))}
        >
            {children}
        </div>
    );
};

export default Fade;
